/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Format_AInputs */

const en_road_dude_faq_format_a = /** @type {(inputs: Road_Dude_Faq_Format_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 9:16 frame fills most short-form feeds. For image-to-video, use a portrait reference or crop the finished clip to 9:16, keeping the driver’s face and the window in frame.`)
};

const zh_road_dude_faq_format_a = /** @type {(inputs: Road_Dude_Faq_Format_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9:16 竖屏适合大多数短视频平台。图生视频可使用竖版参考图，或在成片后裁为 9:16，记得把司机的脸和车窗留在画面里。`)
};

/**
* | output |
* | --- |
* | "A 9:16 frame fills most short-form feeds. For image-to-video, use a portrait reference or crop the finished clip to 9:16, keeping the driver’s face and the w..." |
*
* @param {Road_Dude_Faq_Format_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_format_a = /** @type {((inputs?: Road_Dude_Faq_Format_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Format_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_format_a(inputs)
	return zh_road_dude_faq_format_a(inputs)
});
export { road_dude_faq_format_a as "road_dude.faq.format.a" }